// Constants

export const API_URL: string = location.protocol + '//' + window.location.hostname + '/eSign/api/';
//export const API_URL: string = 'http://' + window.location.hostname + ':11101/api/';
//export const API_URL: string = 'http://192.168.10.227/eSign/api/';





// Api Controller Names Starts
export const API_Signature: string = 'Signature';
export const API_eDictate: string = 'eDictate';
export const API_Picture: string = 'Picture';
export const API_Attachment: string = 'Attachment';


// WEBPACK FOOTER //
// ./SignClient/app/core/apiconfig.ts